<div class="position-relative"><span class="form-control-plaintext" v-translate="getTranslation()"></span></div>